<div class="flex flex-col" style="max-height: 85vh; width: 100%;">

  <div class="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
    <div class="flex items-center gap-3">
      <img [ngSrc]="promo?.image || 'assets/images/promos.webp'"
           [alt]="promo?.title || 'Promotion'"
           width="48"
           height="48"
           priority
           class=" object-cover">
        <h2 class="text-site text-lg font-semibold">{{ promo?.title }}</h2>
      </div>
      <button (click)="cancel()" class="text-gray-400 hover:text-gray-600 cursor-pointer">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if ( promo?.payload.cheapestOffered === true) {
      <div class="bg-[#fcf8e3] border-l-4 border-l-[#8a6d3b] flex items-center mb-0 gap-3 p-3"
        >
        <mat-icon class="warning">warning</mat-icon>
        <p class=" text-[#8a6d3b]">
          La moins chère sera offerte
        </p>
      </div>
    }

    <div class="flex-1 overflow-y-auto px-4 py-4 space-y-6" style="min-height: 0;" #scrollableContent>

      @if (hasProductsToBuy()) {
        <div>
          @if (promo?.payload?.cheapestOffered === false) {
            <h3 class="text-[20px] text-site font-bold mb-3"
            >Produits Achetés</h3>
          }
          @for (rule of promo?.payload?.rules; track rule; let ruleIndex = $index) {
            @if (!rule.offered) {
              <div class="mb-4" [attr.data-rule-id]="rule.id">
                <h4 class="text-[16px] text-site font-semibold mb-3">
                  {{ rule.quantity }} {{ rule.category.name }}
                  @if (rule.sizes && rule.sizes.length > 0) {
                    <span class="text-gray-500 text-[13px]">
                      ({{ getSizesText(rule.sizes) }})
                    </span>
                  }
                </h4>
                <div class="space-y-2">
                  @for (product of rule.products; track product) {
                    <div
                      class="relative flex items-center justify-between px-3 py-2 bg-base-200 label  border rounded-[6px] transition-all"
                      [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
                      [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
                      [class.opacity-60]="!product.available"
                      [class.cursor-not-allowed]="!product.available">
                      @if (!product.available) {
                        <span
                          class="absolute top-1 right-1 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                          Non disponible
                        </span>
                      }
                      <div class="flex items-center gap-3 flex-1 min-w-0">
                        @if (product.image) {
                        <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
                             [alt]="product.name || 'Image à venir'"
                             width="48"
                             height="48"
                             loading="lazy"
                             class=" object-cover">
                        }
                        <div class="flex-1 min-w-0">
                          <p class="text-sm text-site font-medium truncate">{{ product.name }}</p>
                          <p class="text-xs text-site">{{ getProductPrice(product, rule) | number:'1.2-2' }}€</p>
                        </div>
                      </div>
                      <div class="flex items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
                        <button (click)="decrementItem(rule.id, product.id)"
                          [disabled]="getItemQuantity(rule.id, product.id) === 0"
                        class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center
                        hover:text-[#1a1a1a]  justify-center text-gray-700 hover:bg-gray-100
                        disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                          -
                        </button>
                        <span class="font-bold min-w-[20px] text-center ">
                          {{ getItemQuantity(rule.id, product.id) }}
                        </span>
                        <button (click)="incrementItem(rule.id, product.id, ruleIndex)"
                          [disabled]="!product.available"
                        class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center
                        hover:text-[#1a1a1a]  justify-center text-gray-700 hover:bg-gray-100
                        disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                          +
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      }
      @if (hasOfferedProducts()) {
        <div>
          @if (promo?.payload?.cheapestOffered === false) {
            <h3 class="text-[20px] text-site font-bold mb-3"
            >Produits Offerts</h3>
          }
          @for (rule of promo?.payload?.rules; track rule; let ruleIndex = $index) {
            @if (rule.offered) {
              <div class="mb-4" [attr.data-rule-id]="rule.id">
                <h4 class="text-[16px] text-site font-semibold mb-3">
                  {{ rule.quantity }} {{ rule.category.name }}
                  @if (rule.sizes && rule.sizes.length > 0) {
                    <span class="text-gray-500 text-[13px]">
                      ({{ getSizesText(rule.sizes) }})
                    </span>
                  }
                </h4>
                <div class="space-y-2">
                  @for (product of rule.products; track product) {
                    <div
                      class="relative flex items-center justify-between px-3 py-2 bg-base-200 label  border border-[#E7E7E7] rounded-[6px] transition-all"
                      [class.border-orange-500]="getItemQuantity(rule.id, product.id) > 0"
                      [class.shadow-md]="getItemQuantity(rule.id, product.id) > 0"
                      [class.opacity-60]="!product.available"
                      [class.cursor-not-allowed]="!product.available">
                      @if (!product.available) {
                        <span
                          class="absolute top-1 right-1 bg-[#B3261E] text-white text-[10px] font-bold px-2 py-[2px] rounded-[3px] z-10">
                          Non disponible
                        </span>
                      }
                      <div class="flex items-center gap-3 flex-1 min-w-0">
                        @if (product.image) {
                          <img [src]="product.image"
                            class="w-12 h-12 object-cover rounded-md flex-shrink-0" [alt]="product.name">
                        }
                        <div class="flex-1 min-w-0">
                          <p class="text-sm text-site font-medium truncate">{{ product.name }}</p>
                          <p class="text-xs text-site">{{ getProductPrice(product, rule) | number:'1.2-2' }}€</p>
                        </div>
                      </div>
                      <div class="flex items-center gap-2 flex-shrink-0" (click)="$event.stopPropagation()">
                        <button (click)="decrementItem(rule.id, product.id)"
                          [disabled]="getItemQuantity(rule.id, product.id) === 0"
                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center
                        hover:text-[#1a1a1a] justify-center text-gray-700 hover:bg-gray-100
                        disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                          -
                        </button>
                        <span class="font-bold min-w-[20px] text-center ">
                          {{ getItemQuantity(rule.id, product.id) }}
                        </span>
                        <button (click)="incrementItem(rule.id, product.id, ruleIndex)"
                          [disabled]="!product.available"
                        class="w-8 h-8 cursor-pointer rounded-full border border-gray-300 flex items-center
                        hover:text-[#1a1a1a]  justify-center text-gray-700 hover:bg-gray-100
                        disabled:opacity-40 disabled:cursor-not-allowed transition-all">
                          +
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          }
        </div>
      }

    </div>

    <div class="flex-shrink-0 px-4 py-3 border-t border-gray-200">
      <div class="flex-shrink-0 px-4 py-3 ">

        @if (getValidationMessage()) {
          <div
            class="bg-orange-50 border border-orange-300 rounded-lg px-3 py-2 text-sm text-orange-700 font-medium text-center mb-2">
            ⚠️ {{ getValidationMessage() }}
          </div>
        }

        <button
          [matButton]="themeConfig.appearance.button.neutral"
          (click)="toggleCartSheet()"
          [disabled]="!canAddToCart()"
          [class.disabled]="!canAddToCart()"
          class=" w-full">
          <span>Voir détails</span>
        </button>
      </div>
    </div>

  </div>
